var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlPayFullIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon example "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.03385 8.04141C7.55747 8.04141 7.1467 7.87227 6.80156 7.53399C6.45642 7.19572 6.28385 6.78496 6.28385 6.3017C6.28385 5.81845 6.45399 5.40425 6.79427 5.05912C7.13455 4.71398 7.54774 4.54141 8.03385 4.54141C8.51997 4.54141 8.93316 4.71296 9.27344 5.05608C9.61372 5.39919 9.78385 5.81582 9.78385 6.30599C9.78385 6.78805 9.61372 7.1978 9.27344 7.53525C8.93316 7.87269 8.51997 8.04141 8.03385 8.04141ZM2.3901 10.3747V2.22266H13.6922V10.3747H2.3901ZM5.00052 9.20807H11.0818C11.0818 8.80946 11.2204 8.47162 11.4978 8.19453C11.7751 7.91745 12.1177 7.77891 12.5255 7.77891V4.83307C12.1172 4.83307 11.7745 4.68982 11.4974 4.40332C11.2203 4.11681 11.0818 3.77881 11.0818 3.38932H5.00052C5.00052 3.77821 4.8597 4.11606 4.57806 4.40286C4.29641 4.68967 3.95599 4.83307 3.55677 4.83307V7.77891C3.95538 7.77891 4.29566 7.9183 4.5776 8.19708C4.85955 8.47587 5.00052 8.81287 5.00052 9.20807ZM0.304688 12.4602V4.64349H1.63177V11.1331H11.6068V12.4602H0.304688Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlPayFullIcon);
export default __webpack_public_path__ + "static/media/bl-pay-full-icon.141bff1666179d95a8458a509c1d11f9.svg";
export { ForwardRef as ReactComponent };